import {Colors, Fonts} from '../../theme';
import React from 'react';

export default {
  buttonDefault: {
    ...Fonts.style.textMessage,
    background: 'linear-gradient(230.89deg, #7F50B2 0%, #CF1E91 100%',
    color: Colors.white
  },
  buttonCancel: {
    border: 1,
    borderColor: Colors.scbPurple,
    borderStyle: 'solid',
    height: '40px',
    color: Colors.scbPurple,
    background: 'transparent',
  },
  buttonSubmit: {
    border: 1,
    borderColor: Colors.scbPurple,
    borderStyle: 'solid',
    height: '40px',
  },
  buttonModal: {
    backgroundColor: 'transparent',
    color: Colors.scbPurple,
    padding: '8px 0',
    margin: '0',
    borderRadius: '10px',
  },
  buttonRedStyle: {
    backgroundColor: Colors.cherryRed
  },
  buttonRegister: {
    ...Fonts.style.textMessage,
    background: 'linear-gradient(230.89deg, #7F50B2 0%, #CF1E91 100%',
    color: Colors.white,
  },
  buttonAdd: {
    color: Colors.lightPurple,
    borderColor: Colors.lightPurple,
    borderRadius: '4px',
    background: 'transparent',
    fontSize: '16px',
    fontFamily: Fonts.type.KanitRegular,
    height: '40px'
  },
  buttonCenter: {
    textAlign: 'center'
  } as React.CSSProperties,
  buttonGradient: {
    ...Fonts.style.textRegularContent,
    background: 'linear-gradient(230.89deg, #7F50B2 0%, #CF1E91 100%',
    color: Colors.white,
    borderRadius: '4px',
    border: 'none',
    height: '40px'
  },
  buttonModalConfirmGradient: {
    ...Fonts.style.textHeaderKanitRegular16,
    background: 'linear-gradient(230.89deg, #7F50B2 0%, #CF1E91 100%',
    color: Colors.white,
    borderColor: Colors.lightPurple,
    height: '40px',
    width: '114px',
    borderRadius: 5
  },
  buttonModalConfirmGradientDisable: {
    ...Fonts.style.textHeaderKanitRegular16,
    background: 'linear-gradient(230.89deg, #7F50B2 0%, #CF1E91 100%',
    color: Colors.white,
    borderColor: Colors.lightPurple,
    height: '40px',
    width: '114px',
    opacity: 0.4,
    borderRadius: 5
  },
  buttonModalCancelGradient: {
    ...Fonts.style.textHeaderKanitRegular16,
    background: 'transparent',
    borderColor: Colors.lightPurple,
    height: '40px',
    width: '114px',
    color: Colors.lightPurple,
    borderRadius: 5
  },
  buttonFromConfirmGradient: {
    ...Fonts.style.textHeaderKanitRegular16,
    background: 'linear-gradient(230.89deg, #7F50B2 0%, #CF1E91 100%',
    color: Colors.white,
    borderColor: Colors.lightPurple,
    height: '40px',
    width: '114px',
    borderRadius: 5
  },
  buttonFromCancelGradient: {
    ...Fonts.style.textHeaderKanitRegular16,
    background: 'transparent',
    borderColor: Colors.lightPurple,
    height: '40px',
    width: '114px',
    color: Colors.lightPurple,
    borderRadius: 5
  },
  buttonAddMenuDiscount: {
    border: 1,
    borderColor: Colors.borderPurple,
    borderStyle: 'solid',
    height: '40px',
    color: Colors.borderPurple,
    background: 'transparent',
    borderRadius: '40px',
  },
  disabled: {
    opacity: '40%'
  }
};
